import { render, staticRenderFns } from "./NovaPreCotacao.vue?vue&type=template&id=d5198206&scoped=true&"
import script from "./NovaPreCotacao.vue?vue&type=script&lang=js&"
export * from "./NovaPreCotacao.vue?vue&type=script&lang=js&"
import style0 from "./NovaPreCotacao.vue?vue&type=style&index=0&id=d5198206&lang=scss&scoped=true&"
import style1 from "./NovaPreCotacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5198206",
  null
  
)

export default component.exports